import cx from "classnames";
import type React from "react";
import { CloseIcon } from "@/icons";
import styles from "./BaseInput.module.scss";

type InputProps = {
    id?: string;
    value?: string;
    maxLength?: number;
    label?: string;
    error?: string;
    inputRef?: React.Ref<HTMLInputElement>;
    className?: string;
    onChange?: (value: string) => void;
    onKeyDown?: (e: React.KeyboardEvent<HTMLInputElement>) => void;
    onFocus?: () => void;
    onBlur?: () => void;
    onCancel?: () => void;
};

export const BaseInput = ({
    id,
    value = "",
    maxLength = 100,
    label = "",
    error = "",
    inputRef,
    className,
    onChange,
    onKeyDown,
    onFocus,
    onBlur,
    onCancel,
}: InputProps) => {
    return (
        <div className={cx(styles.baseInputWrapper, error && styles.error, className)}>
            <input
                ref={inputRef}
                id={id}
                maxLength={maxLength}
                value={value}
                onChange={(e) => onChange?.(e.currentTarget.value)}
                onKeyDown={onKeyDown}
                onFocus={onFocus}
                onBlur={onBlur}
                className={styles.baseInput}
                type="text"
            />

            {label && (
                <label className={styles.baseInputLabel} htmlFor={id}>
                    {label}
                </label>
            )}

            {onCancel && (
                <div className={styles.baseInputButton} onMouseDown={onCancel}>
                    <CloseIcon />
                </div>
            )}

            {error && <span className={styles.baseInputError}>{error}</span>}
        </div>
    );
};
